'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _api = require('./api');

var _api2 = _interopRequireDefault(_api);

var _enhanced = require('./enhanced');

var _enhanced2 = _interopRequireDefault(_enhanced);

exports['default'] = function (options) {
	var opts = (0, _objectAssign2['default'])({}, options);
	var api = new _api2['default'](opts.params);

	if (opts.enhanced) {
		api.enhanced = new _enhanced2['default']();
	}

	return api;
};

module.exports = exports['default'];